import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    background-color: #FFFFFF;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-start;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 30px;
    padding-top: 30px;

    @media only screen and (max-width: 768px) {
        padding-left: 8px;
        padding-right: 8px;
        padding-bottom: 8px;
    }
`;

export const HeaderPlans = styled.div`
    display: flex;
    max-width: 1100px;
    justify-content: space-between;
    margin-inline: 0;
    align-items: center;
    background-color: #FFFFFF;
    width: 100%;

    .image {
        width: 100%;
        max-width: 255px;

        img {
            width: 10.625rem;
            height: 2.375rem;
        }
    }

    .links {
        width: 100%;
        max-width: 255px;

        gap: 1.5rem;
        display: flex;

        font-size: 0.625rem;
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: 0.1rem;
        justify-content: center;

        a {
            color: ${theme.colors.gray.Cinza_2};
            padding: 0.7rem;
            border-radius: 1rem;
            transition: background-color 300ms ease;

            &:hover {
                background-color: lightgray;

            }
        }
    }

    .buttons-plans {
        display: flex;
        gap: 10px;

        > :nth-child(1){
            all: unset;
            cursor: pointer;
            background-color: #FFFFFF;
            padding: 12px 24px;
            border: 2px solid ${theme.colors.gray.Cinza_2};
            border-radius: 50px;
            font-size: 11px;
            letter-spacing: 0.1rem;
            font-weight: 800;
            text-transform: uppercase;
            color: ${theme.colors.gray.Cinza_2};
            transition: scale 500ms ease;

            &:hover {
                scale: 1.1;
                color: #FFFFFF;
                background-color: ${theme.colors.gray.Cinza_2};
            }
        }

        > :nth-child(2){
            all: unset;
            cursor: pointer;
            background-color: #2FBB69;
            padding: 16px 24px 16px 24px;
            border-radius: 50px;
            font-size: 11px;
            letter-spacing: 0.1rem;
            font-weight: 800;
            text-transform: uppercase;
            color: white;
            transition: scale 500ms ease;

            &:hover {
                scale: 1.1;
            }
        }
    }

    .mobile-only {
        display: none;
    }

    @media (max-width: 911px) {
        justify-content: space-between;
        padding: 1rem;

        .buttons-plans {
            display: none;
        }

        .links {
            display: none;
        }

        .mobile-only {
            display: flex;
            gap: 12px;
            letter-spacing: 0.1rem;
            font-size: 10px;
            text-transform: uppercase;

            a {
                color: ${theme.colors.gray.Cinza_2};
                cursor: pointer;
            }
        }
    }
`;
